export default {
  isLoggedIn: state => state.isLoggedIn,
  authUser: state => state.authUser
}
